import * as amplitude from "@amplitude/analytics-browser";
import { sessionReplayPlugin, SessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";

let plugin: SessionReplayPlugin | null = null;
let isReady = false;
// Latest requested state; applied after the async plugin setup finishes.
let shouldRecord = false;
// Last state applied to the SDK; actual capture still depends on sampling and opt-out.
let recordingEnabled = false;

const applyState = (): void => {
    if (!plugin || !isReady || shouldRecord === recordingEnabled) return;
    recordingEnabled = shouldRecord;
    if (shouldRecord) {
        void plugin.start();
    } else {
        plugin.stop();
    }
};

// Adds the plugin once, then starts/stops recording as the route becomes allowed/excluded.
export const syncSessionReplay = (record: boolean): void => {
    shouldRecord = record;

    if (plugin) {
        applyState();
    } else if (record) {
        const instance = sessionReplayPlugin({ sampleRate: 1.0 });
        plugin = instance;
        // Setup starts recording, so re-apply the latest state in case the route changed meanwhile.
        void amplitude.add(instance).promise.then(() => {
            isReady = true;
            recordingEnabled = true;
            applyState();
        });
    }
};

const normalizePath = (path: string): string => `/${path.split("/").filter(Boolean).join("/")}`;

// Matches the full flow-relative path (e.g. "/quiz/5"), ignoring the flow root segment (e.g. "/new-h").
export const isReplayPathAllowed = (
    pathname: string,
    currentFlow: string | null,
    allowedPaths: string[]
): boolean => {
    const segments = pathname.split("/").filter(Boolean);
    if (currentFlow && segments[0] === currentFlow) segments.shift();

    const relativePath = normalizePath(segments.join("/"));
    return allowedPaths.some((path) => normalizePath(path) === relativePath);
};
